export const FRONT_AREA = {
  'sylvette-la-crevette':
    'La couleur de sa petite silhouette, visage conservé.',
  'leon-le-citron': 'La couleur du citron, lunettes et broderies conservées.',
  'pralin-le-cornet': 'La boule change de couleur ; le cornet reste naturel.',
  'pepin-le-sorbet':
    'Choisissez séparément les trois bandes ; le bâton reste naturel.',
  'camille-la-coquille':
    'La coquille change de couleur ; le visage blanc reste.',
};
export const BACK_TEXTURES = Object.fromEntries(
  [
    'blue-flowers',
    'pastel-flowers',
    'vivid-flowers',
    'autumn-flowers',
    'meadow-flowers',
  ].map((id) => [id, `/images/configurator/materials-v2/${id}.webp`]),
);
export function fabricStyle(option) {
  const fronts = [
    'pink',
    'fuchsia',
    'coral',
    'honey',
    'lemon',
    'ivory',
    'blue',
    'teal',
    'periwinkle',
    'chocolate',
    'grey',
    'red',
    'burgundy',
  ].map((id) => id + '-minkee');
  const texture = option.swatch_image || (fronts.includes(option.option_id)
    ? `/images/configurator/materials-v2/${option.option_id}-thumb.webp`
    : BACK_TEXTURES[option.option_id]?.replace('.webp', '-thumb.webp'));
  return {
    backgroundColor: option.hex,
    backgroundImage:
      texture || option.image ? `url("${texture || option.image}")` : undefined,
    backgroundPosition: texture ? 'center' : option.image_position || 'center',
    backgroundSize: texture ? 'cover' : option.image_size || 'cover',
  };
}
